/**
 * Prijzen en abonnementen (de commerciële console, ADR-0018 §4a), in het
 * Nederlands. Dezelfde sleutels als billing.fr.ts, de referentietaal.
 */
export const billingNl = {
  "billing.tabs.aria": "Prijzen en abonnementen",
  "billing.tab.prices": "Prijzen",
  "billing.tab.promos": "Acties",
  "billing.tab.discounts": "Kortingen",
  "billing.refreshFailed": "De lijst kon niet worden ververst: hij staat er zoals hij was.",
  "billing.anyPlan": "Alle abonnementen",
  "billing.planWithInterval": "{name}, gefactureerd {interval}",
  "billing.interval.month": "per maand",
  "billing.interval.year": "per jaar",
  "billing.window": "van {from} tot {to}",
  "billing.window.endedEarly": "gestopt op {date}",
  "billing.periods.whileSubscribed": "zolang het abonnement loopt",
  "billing.periods.count": "{count} betaalde periodes",
  "billing.state.scheduled": "Gepland",
  "billing.state.running": "Loopt",
  "billing.state.finished": "Afgelopen",
  "billing.state.ended_early": "Vroegtijdig gestopt",
  "billing.scope.pro": "Eén vakman",
  "billing.scope.country": "Een land",
  "billing.scope.category": "Een vak",
  "billing.priceState.in_force": "Van kracht",
  "billing.priceState.scheduled": "Gepland",
  "billing.priceState.superseded": "Vervangen",
  "billing.prices.intro":
    "Een nieuwe prijs geldt alleen voor nieuwe abonnementen. Een vakman houdt de prijs waarvoor hij afsloot.",
  "billing.prices.loading": "Prijzen laden…",
  "billing.prices.loadFailed": "De prijzen konden niet worden geladen.",
  "billing.prices.empty": "Er is nog geen prijs ingesteld.",
  "billing.prices.unpriced": "Zonder prijs: {plans}. Niemand kan zich hierop abonneren.",
  "billing.prices.imported": "Uit het oorspronkelijke tarief",
  "billing.promos.intro":
    "Een actie verlaagt de prijs van een abonnement in één land, voor wie binnen het venster afsluit. Een vakman krijgt alleen de laagste prijs: actie en korting stapelen niet.",
  "billing.promos.loading": "Acties laden…",
  "billing.promos.loadFailed": "De acties konden niet worden geladen.",
  "billing.promos.empty": "Voorlopig geen acties.",
  "billing.discounts.intro":
    "Een korting is een percentage voor één vakman, een land of een vak. Een vakman krijgt alleen de laagste prijs: korting en actie stapelen niet.",
  "billing.discounts.loading": "Kortingen laden…",
  "billing.discounts.loadFailed": "De kortingen konden niet worden geladen.",
  "billing.discounts.empty": "Voorlopig geen kortingen.",
  "billing.col.name": "Naam",
  "billing.col.plan": "Abonnement",
  "billing.col.country": "Land",
  "billing.col.currency": "Valuta",
  "billing.col.amount": "Bedrag",
  "billing.col.amountDue": "Nog te betalen",
  "billing.col.promoPrice": "Actieprijs",
  "billing.col.percentOff": "Korting",
  "billing.col.periods": "Duur",
  "billing.col.window": "Venster",
  "billing.col.state": "Status",
  "billing.col.status": "Betaalstatus",
  "billing.col.subscribers": "Vakmensen erop",
  "billing.col.createdBy": "Aangemaakt door",
  "billing.col.setBy": "Ingesteld door",
  "billing.col.reason": "Reden",
  "billing.col.validFrom": "Geldig vanaf",
  "billing.col.who": "Voor wie",
  "billing.col.actions": "Acties",
  "billing.col.date": "Datum",
  "billing.col.period": "Gedekte periode",
  "billing.col.provider": "Aanbieder",
  "billing.col.eventKind": "Gebeurtenis",
  "billing.col.via": "Binnen via",
  "billing.col.result": "Resultaat",
  "billing.col.detail": "Toelichting",
  "billing.col.eventRef": "Gebeurtenisreferentie",
  "billing.action.setPrice": "Prijs instellen",
  "billing.action.newPromo": "Nieuwe actie",
  "billing.action.newDiscount": "Nieuwe korting",
  "billing.action.endNow": "Nu stoppen",
  "billing.action.endPromo": "Actie stoppen",
  "billing.action.endDiscount": "Korting stoppen",
  "billing.action.extendSubscription": "Verlengen",
  "billing.action.endSubscription": "Abonnement beëindigen",
  "billing.dialog.setPrice.title": "Prijs instellen",
  "billing.dialog.setPrice.body":
    "Deze prijs geldt voor nieuwe abonnementen in dat land. Wie al is geabonneerd, houdt zijn prijs.",
  "billing.dialog.newPromo.title": "Nieuwe actie",
  "billing.dialog.newPromo.body":
    "De actieprijs vervangt de landprijs binnen het venster. Een vakman houdt hem zolang het abonnement loopt, tot de opgegeven grens.",
  "billing.dialog.newDiscount.title": "Nieuwe korting",
  "billing.dialog.newDiscount.body":
    "Kies precies één doel: één vakman, een land of een vak. Een vakman krijgt alleen de laagste prijs: korting en actie stapelen niet.",
  "billing.dialog.endPromo.title": "Actie {subject} stoppen",
  "billing.dialog.endPromo.body": "Niemand kan hem nog nieuw krijgen. Wie hem al heeft, houdt hem.",
  "billing.dialog.endDiscount.title": "Korting {subject} stoppen",
  "billing.dialog.endDiscount.body": "Hij geldt niet meer voor nieuwe abonnementen. Wie hem al heeft, houdt hem.",
  "billing.dialog.extendSubscription.title": "{subject} verlengen",
  "billing.dialog.extendSubscription.body":
    "Coulance: de toegang loopt tot de gekozen datum en een schorsing wordt opgeheven. De prijs van de vakman verandert niet.",
  "billing.dialog.endSubscription.title": "Abonnement {subject} beëindigen",
  "billing.dialog.endSubscription.body":
    "De toegang stopt meteen en de aanbieder krijgt opdracht niets meer af te schrijven. Er is geen terugbetaling: geef een tegoed vanuit Paiements als dat verschuldigd is.",
  "billing.field.plan": "Abonnement",
  "billing.field.pickPlan": "Kies een abonnement",
  "billing.field.country": "Land",
  "billing.field.countryHint": "Tweeletterige code, bijvoorbeeld GN.",
  "billing.field.currency": "Valuta",
  "billing.field.currencyHint": "Drieletterige code, bijvoorbeeld GNF.",
  "billing.field.amount": "Prijs ({currency})",
  "billing.field.validFrom": "Geldig vanaf (optioneel)",
  "billing.field.validFromHint": "Leeg: de prijs geldt meteen. Nooit een datum in het verleden.",
  "billing.field.name": "Naam",
  "billing.field.nameHint": "Wat het team in de lijst ziet, bijvoorbeeld ‘Start Conakry’.",
  "billing.field.startsAt": "Start",
  "billing.field.endsAt": "Einde",
  "billing.field.periods": "Aantal periodes (optioneel)",
  "billing.field.periodsHint": "Leeg: de vakman houdt de prijs zolang het abonnement loopt.",
  "billing.field.scope": "Voor wie",
  "billing.field.pro": "De vakman",
  "billing.field.category": "Vak",
  "billing.field.pickCategory": "Kies een vak",
  "billing.field.percentOff": "Kortingspercentage",
  "billing.field.paidThrough": "Verlengen tot",
  "billing.field.paidThroughHint": "Een datum in de toekomst. Tot dan loopt de toegang.",
  "billing.problem.reason": "Geef een reden van minstens {min} tekens.",
  "billing.problem.plan": "Kies een abonnement.",
  "billing.problem.country": "Typ een tweeletterige landcode.",
  "billing.problem.currency": "Typ een drieletterige valutacode.",
  "billing.problem.amount": "Typ een bedrag boven nul.",
  "billing.problem.validFrom": "Geef een geldige startdatum.",
  "billing.problem.backdated": "Een prijs kan niet in het verleden ingaan.",
  "billing.problem.name": "Geef een naam van minstens {min} tekens.",
  "billing.problem.window": "Geef een start en een einde.",
  "billing.problem.windowOrder": "Het einde moet na de start liggen.",
  "billing.problem.periods": "Het aantal periodes moet een geheel getal boven nul zijn.",
  "billing.problem.pro": "Kies de vakman om wie het gaat.",
  "billing.problem.category": "Kies een vak.",
  "billing.problem.percentOff": "Het percentage moet een geheel getal tussen 1 en 100 zijn.",
  "billing.problem.paidThrough": "Geef een geldige einddatum.",
  "billing.problem.paidThroughPast": "De datum moet in de toekomst liggen.",
  "billing.outcome.price": "Prijs vastgelegd: {amount}, vanaf {date}.",
  "billing.outcome.promoCreated": "Actie ‘{name}’ aangemaakt.",
  "billing.outcome.promoEnded": "Actie ‘{name}’ gestopt. Wie hem al heeft, houdt hem.",
  "billing.outcome.discountCreated": "Korting ‘{name}’ aangemaakt.",
  "billing.outcome.discountEnded": "Korting ‘{name}’ gestopt. Wie hem al heeft, houdt hem.",
  "billing.outcome.extended": "Abonnement verlengd tot {date}.",
  "billing.outcome.subscriptionEnded":
    "Abonnement beëindigd. De toegang is afgesloten en de aanbieder schrijft niets meer af.",
  "billing.error.stale": "Dit is gewijzigd terwijl u keek. Herlaad, controleer en probeer opnieuw.",
  "billing.error.refused":
    "Geweigerd: uw rollen bevatten de benodigde functie niet. Vraag een leidinggevende om toegang.",
  "billing.error.invalid": "Geweigerd: wat is verstuurd klopt niet meer. Herlaad en controleer.",
  "billing.error.outcomeUnknown":
    "Geen antwoord van de server: het kan al vastgelegd zijn. Probeer opnieuw: dezelfde klik telt niet twee keer.",
  "billing.refused.planNotPriced": "Geweigerd: dit abonnement heeft nog geen prijs in dat land. Stel die eerst in.",
  "billing.refused.invalidAmount": "Geweigerd: het bedrag moet boven nul liggen.",
  "billing.refused.backdated": "Geweigerd: een prijs kan niet in het verleden ingaan.",
  "billing.refused.priceVersionExists":
    "Geweigerd: er begint al een versie op dat moment voor dit abonnement en land. Herlaad de lijst.",
  "billing.refused.invalidWindow": "Geweigerd: het venster klopt niet. Het einde moet na de start liggen.",
  "billing.refused.alreadyOver": "Geweigerd: dit is al afgelopen. Herlaad de lijst.",
  "billing.refused.idempotencyKeyRequired":
    "Geweigerd: het verzoek vertrok zonder sleutel. Sluit het venster en begin opnieuw.",
  "billing.subscription.pending": "In behandeling",
  "billing.subscription.active": "Actief",
  "billing.subscription.ending": "Verlengt niet",
  "billing.subscription.suspended": "Geschorst",
  "billing.subscription.ended": "Beëindigd",
  "billing.endReason.renewal_cancelled": "Verlenging opgezegd door de vakman",
  "billing.endReason.unpaid": "Verlenging niet betaald",
  "billing.endReason.checkout_abandoned": "Betaling nooit voltooid",
  "billing.endReason.replaced": "Vervangen door een ander abonnement",
  "billing.endReason.ended_by_staff": "Beëindigd door het team",
  "billing.endReason.ended_by_provider": "Beëindigd door de aanbieder",
  "billing.event.payment_succeeded": "Betaling geslaagd",
  "billing.event.payment_failed": "Betaling mislukt",
  "billing.event.subscription_ended": "Abonnement beëindigd",
  "billing.via.webhook": "Webhook van de aanbieder",
  "billing.via.poll": "Door Walliyo opgevraagd",
  "billing.via.return": "Terugkeer in de app",
  "billing.via.reconcile": "Afstemming",
  "billing.result.applied": "Toegepast",
  "billing.result.conflict": "Botsing",
  "billing.result.ignored": "Genegeerd",
  "billing.priceInsteadOf": "{now} in plaats van {regular}",
  "billing.reductionWithPeriods": "{name} · nog {count} periodes",
  "billing.sub.loading": "Abonnement laden…",
  "billing.sub.loadFailed": "Het abonnement kon niet worden geladen.",
  "billing.sub.none": "Deze vakman is nooit geabonneerd geweest.",
  "billing.sub.credit": "Tegoed",
  "billing.sub.noCredit": "Geen",
  "billing.sub.noRefunds":
    "Op een abonnement is er geen terugbetaling. Een gebaar is een tegoed vanuit Paiements, dat van de volgende betaling af gaat.",
  "billing.sub.creditLink": "Zijn betalingen, om een tegoed te geven →",
  "billing.sub.discountLink": "Deze vakman een korting geven →",
  "billing.sub.since": "Geopend op {date}",
  "billing.sub.versionTitle": "De getoonde abonnementsversie: elke schrijfactie stuurt hem mee.",
  "billing.sub.entitled": "Toegang open",
  "billing.sub.notEntitled": "Geen toegang",
  "billing.sub.provider": "Aanbieder",
  "billing.sub.renewsAutomatically": "verlengt automatisch",
  "billing.sub.paidByHand": "door de vakman zelf betaald",
  "billing.sub.country": "Land",
  "billing.sub.price": "Huidige prijs",
  "billing.sub.reduction": "Verlaging",
  "billing.sub.nextPlan": "Wisseling van abonnement",
  "billing.sub.nextPlanValue": "gaat aan het einde van de periode over naar {plan}",
  "billing.sub.paidThrough": "Betaald tot",
  "billing.sub.renewalCancelled": "Verlenging opgezegd op",
  "billing.sub.graceEnds": "Respijt loopt tot",
  "billing.sub.ended": "Beëindigd op",
  "billing.sub.endReason": "Reden van het einde",
  "billing.sub.payments": "Betalingen",
  "billing.sub.noPayments": "Geen betaling op dit abonnement.",
  "billing.sub.noPeriod": "Nog niet gedekt",
  "billing.sub.events": "Gebeurtenissen van de aanbieder",
  "billing.sub.noEvents": "Geen gebeurtenis van de aanbieder.",
  "billing.sub.actions": "Ingrijpen op dit abonnement",
  "billing.sub.actionsFoot":
    "Verlengen is coulance, beëindigen is handhaving. Beide vragen een reden en komen in het auditlogboek.",
} as const;
